import "./Hero.scss";

import { useRef } from "react";
import { useTranslation } from "react-i18next";

import { Logo, LogoHorse } from "../../../assets/svg/svgIcons";
import Button from "../../../components/Utils/Button/Button";
import useAnimation from "../../../hooks/useAnimation";
import getImageUrl from "../../../Utils/Services/img/imgFetch";

function Hero() {
  const { t, i18n } = useTranslation();

  const heroTextRef = useRef(null);
  const buttonRef = useRef(null);
  const { scrollToSection } = useAnimation();

  return (
    <section className="hero" id="hero">
      <div className="overflow-wrap">
        <img
          src={getImageUrl("hero/hero.jpg")}
          alt="4x4 Vert"
          className="hero-image"
        />
      </div>

      <div className="hero-text" ref={heroTextRef}>
        <div className="heroLogos">
          <LogoHorse className="logoHorse" />
          <Logo className="logo" />
        </div>
        <Button
          ref={buttonRef}
          onClick={() => scrollToSection("contact")}
          className="button"
          label={t("home.hero.contactButton")}
        />
      </div>
    </section>
  );
}

export default Hero;
